import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { ErmCapabilityRoutingModule } from './erm-capability-routing.module';
import { ErmCapabilityGuard } from './erm-capability.guard';
import { HomeComponent } from './pages/home/home.component';
import { LaunchErrorComponent } from './pages/launch/launch-error.component';
import { LaunchNativeComponent } from './pages/launch/launch-native.component';
import { LaunchComponent } from './pages/launch/launch.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { LaunchButtonComponent } from './pages/launch/launch-button.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErmSdkModule } from 'erm-sdk';
import { LayoutComponent } from './components/layout/layout.component';
import { EnvironmentComponent } from './features/environment/environment.component';
import { ErrorMessageComponent } from './features/environment/components/error-message.component';
@NgModule({
  imports: [
    BrowserAnimationsModule,
    CommonModule,
    ErmCapabilityRoutingModule,
    ErmSdkModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    LayoutComponent,
    EnvironmentComponent,
    ErrorMessageComponent
  ],
  providers: [
    ErmCapabilityGuard
  ],
  declarations: [
    HomeComponent,
    LaunchButtonComponent,
    LaunchComponent,
    LaunchErrorComponent,
    LaunchNativeComponent,
    SettingsComponent
  ]
})
export class ErmCapabilityModule { }
